import React from 'react'
import AccordionEmployeeTable from './accordionEmployeeTable';
import { BACKEND_API_URL } from '../../../../config';
import { getFileName, toFileList } from '../../../../features/utils';
import AccordionBusinessTable from './accordionBusinessTable';

const InfoItem = ({ label, value, wide = false }) => (
    <div className={`rounded-xl border border-slate-200 bg-white p-3 shadow-sm ${wide ? 'sm:col-span-2' : ''}`}>
        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">{label}</p>
        <p className="mt-1 whitespace-normal break-words text-sm font-semibold text-[#211b4f]">{value || 'NA'}</p>
    </div>
);


const ProfileModalSectionRender = React.forwardRef(({ name, data, pl='' }, ref)  => {  
    const handleFileDownload = (e, filePath) => {
        e.preventDefault()
        const url = `${BACKEND_API_URL}/api/files/download?path=${encodeURIComponent(filePath)}`;
          fetch(url)
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // Specify a filename for the downloaded file
                a.download = getFileName(filePath) || 'download';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(err => {
                console.error('Fetch error:', err)
                alert("Failed to download file.")
            });
      };

    switch (name) {
        case 'manager': 
            return (
                <div ref={ref} className="profile-review-scrollbar h-full overflow-y-auto px-12 py-4 sm:px-14">
                    <div className="mx-auto max-w-4xl whitespace-normal">
                        <h1 className="mb-5 text-xl font-bold text-[#0a1445] sm:text-2xl">Manager Information</h1>
                        <section className="grid gap-3 sm:grid-cols-2">
                            <InfoItem label="First Name" value={data.firstName} />
                            <InfoItem label="Last Name" value={data.lastName} />
                            <InfoItem label="Title" value={data.title} />
                            <InfoItem label="Email" value={data.email} />
                            <InfoItem label="Cell Number" value={data.cellNumber} />
                            <InfoItem label="Office Number" value={data.officeNumber} />
                            <InfoItem label="NMLS" value={data.nmls} />
                        </section>

                        <h2 className="mb-4 mt-7 text-lg font-bold text-[#0a1445]">Position and Compensation Information</h2>
                        <section className="grid gap-3 sm:grid-cols-2">
                            <InfoItem label="Title" value={data.title} />
                            <InfoItem label="Employment Type" value={data.employementType} />
                            <InfoItem label="Compensation Rate" value={data.compensationRate ? `$ ${data.compensationRate}` : '- -'} />
                            <InfoItem label="Will this employee be originating loans?" value={data.isOriginatingLoans ? 'Yes' : 'No'} />
                            <InfoItem label="Will the Candidate participate in the P and L?" value={pl} />
                            <InfoItem label="Is there any type of override or bonus?" value={data?.bonus?.value || 'No'} />
                            <InfoItem label="Is there any type of sign-on bonus or upfront incentive?" value={data?.upfront?.value || 'No'} />
                            <InfoItem label="Compensation and Other Notes regarding the new hire" value={data?.notes} wide />
                        </section>
                    </div>
                </div>
            )
        case 'employees':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Employees Information
                    </h1>

                    <div className="rounded-lg shadow-sm border-slate-200  w-full">
                            <table className="w-full   divide-y divide-slate-200  border-spacing-y-6">
                                <tbody className="text-sm">
                                {
                                    data?.data?.map((item, index) => {
                                        return (
                                        <AccordionEmployeeTable
                                            key={index}
                                            data={item}
                                        />
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                    </div>
                </div>
            )
        
        case 'license_states':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        License States
                    </h1>
                    {data?.map(name => (
                        <h2 className="text-md text-[#0a1445] text-center py-3 border-b border-slate-200" key={name}>{name}</h2>
                    ))}
                </div>
            )
        
        case 'branch_location':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Branch Location Details
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Branch Type
                                </div>
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data._type}</span>
                                </div>
                            </li>
                            { data._type === 'Satellite' && (
                                <>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            Branch Name
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data._branch['BranchNickname']  || 'NA'}</span>
                                        </div>
                                    </li>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            Branch Cost Center ID
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data._branch['CostCenterID']  || 'NA'}</span>
                                        </div>
                                    </li>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            Branch Address
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4 flex justify-start whitespace-normal">
                                            <span className="mr-3">{data._branch['Address']  || 'NA'}</span>
                                        </div>
                                    </li>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            Branch Manager
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data._branch['BranchManager']  || 'NA'}</span>
                                        </div>
                                    </li>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            State
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data._branch['State']  || 'NA'}</span>
                                        </div>
                                    </li>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            City
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data._branch['City']  || 'NA'}</span>
                                        </div>
                                    </li>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            Zip Code
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data._branch['ZipCode']  || 'NA'}</span>
                                        </div>
                                    </li>
                                </>
                            )}
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Option
                                </div>
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data._option}</span>
                                </div>
                            </li>
                            
                        </ul>
                    </section> 

                    { (data._option === 'Existing Location with Lease' || data._option === 'Existing Location without Lease') && (
                        <>
                        <section>
                            <ul className='max-w-lg mx-auto'>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Address
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4 flex-1 flex justify-end whitespace-normal">
                                        <span className="mr-3 block break-words">{data.address}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Tenant
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.tenant}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Landlord
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.landlord}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Landlord Phone Number
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.landlordPhoneNumber}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Landlord Email
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.landlordEmail}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Total Monthly Rent including Taxes & CAM
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">$ {data.amount}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Lease Agreement
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <button 
                                            className="font-medium text-blue-600  hover:underline mr-3"
                                            onClick={e => handleFileDownload(e, data.agreementFile)}
                                            >
                                                Download
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </section>
                        </>
                    )}
                </div>
            )

        case 'processing_plan':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Processing Plan
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    What is your processing plan?
                                </div>
                                <div className="text-sm text-slate-600  ml-4">
                                    <span className="mr-3">{data?.option || 'NA'}</span>
                                </div>
                            </li>
                            { data?.option === 'Other' && (
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Please specify
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4 flex-1 flex justify-end whitespace-normal">
                                        <span className="mr-3 block break-words">{data?.other || 'NA'}</span>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </section>
                </div>
            )

        case 'margin_management':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Margin Management
                    </h1>

                    <div className="rounded-lg shadow-sm border-slate-200  w-full">
                            <table className="w-full   divide-y divide-slate-200  border-spacing-y-6">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50  ">
                                    <tr>
                                        <th scope="col" className="px-6 py-3">
                                            Product
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Margin
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Branch Revenue Cap
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="text-sm">
                                {
                                    data?.products?.map((product, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <tr className="bg-white border-b  ">
                                                    <th scope="row" className="text-sm px-6 py-3 font-medium text-gray-900 whitespace-nowrap ">
                                                        {product?.name}
                                                    </th>
                                                    <td className="text-sm px-6 py-3">
                                                        {product?.margin} %
                                                    </td>
                                                    <td className="text-sm px-6 py-3">
                                                        {product?.revenueCap || '- -'}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                    </div>
                </div>
            )

        case 'locking_cabinet':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Cabinet Details
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Do you have a compliant micro-cut shredder?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data.shredder_option}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Shredder Image
                                </div>
                                {data.shredder_image === 'No' ? <div className="text-sm text-slate-600  ml-4">
                                                                    <span className="mr-3">{'NA'}</span>
                                                                </div>
                                :
                                    <div className="text-sm text-slate-600  ml-4">
                                        <button 
                                            className="font-medium text-blue-600  hover:underline mr-3"
                                            onClick={e => handleFileDownload(e, data.shredder_image)}
                                            >
                                                Download
                                        </button>
                                    </div>
                                }
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Do you have a locking file cabinet?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data._option}</span>
                                </div>
                            </li>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    File Cabinet Image
                                </div>
                                {data.shredder_image === 'No' ? <div className="text-sm text-slate-600  ml-4">
                                                                    <span className="mr-3">{'NA'}</span>
                                                                </div>
                                :
                                    <div className="text-sm text-slate-600  ml-4">
                                        <button 
                                            className="font-medium text-blue-600  hover:underline mr-3"
                                            onClick={e => handleFileDownload(e, data._image)}
                                            >
                                                Download
                                        </button>
                                    </div>
                                }
                            </li>
                            
                        </ul>
                    </section> 
                </div>
            )

        case 'local_it_company':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Local IT Company Details
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Do you work with a local IT company?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data._option}</span>
                                </div>
                            </li>
                            {data._option === 'Yes' && 
                                <>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Company Name
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.company}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Contact Name
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.contactName}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Contact Email
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.email}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Contact Phone Number
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.contactPhone}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        IT Services Provided
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4 flex-1 flex justify-end whitespace-normal">
                                        <span className="mr-3 block break-words">{data.servicesProvided}</span>
                                    </div>
                                </li>
                                </>
                            }
                            
                        </ul>
                    </section> 
                </div>
            )

        case 'office_space':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Office Space Details
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium flex-1 flex justify-end whitespace-normal">
                                    Does your location have a private place to meet, exclusive to mortgage, behind a closed door?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data?.office_space_detail?.place_option}</span>
                                </div>
                            </li>

                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium pl-8">
                                    Do you share office space with any other business?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data?.office_space_detail?._option}</span>
                                </div>
                            </li>
                        </ul>
                    </section>
                    {/* List of businesses */}
                    <div className="rounded-lg shadow-sm border-slate-200  w-full mt-10">
                        <h1 className="text-lg text-[#0a1445]  font-medium text-center mb-4">
                            Other Businesses
                        </h1>
                        <table className="w-full   divide-y divide-slate-200  border-spacing-y-6">
                            <tbody className="text-sm">
                            {
                                data?.related_businesses?.map((item, index) => {
                                    return (
                                    <AccordionBusinessTable
                                        key={index}
                                        data={item}
                                    />
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            )

        case 'mortgage_sign':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Rize Mortgage Sign Details
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Do you have a Rize Mortgage Sign for your office?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data?.sign_option}</span>
                                </div>
                            </li>
                            { data?.sign_option === 'Yes' && (
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Sign Image
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <button 
                                            className="font-medium text-blue-600  hover:underline mr-3"
                                            onClick={e => handleFileDownload(e, data._image)}
                                            >
                                                Download
                                        </button>
                                    </div>
                                </li>
                            )}
                            { data?.sign_option === 'No' && (
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Do you need the Rize Logo for your sign provider?
                                    </div>
                                    <div className="text-sm text-indigo-600  ml-4">
                                        <span className="mr-3">{data?.logo_option}</span>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </section>
                </div>
            )

        case 'compliance_signage':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Compliance Signage
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            {/* Fair Housong Poster */}
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Do you have an Equal Housing Lender/ECOA poster/sign in your office?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data?.fairhousing_sign_option}</span>
                                </div>
                            </li>
                            { data?.fairhousing_sign_option === 'Yes' && (
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Equal Housing Lender/ECOA poster/sign
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <button 
                                            className="font-medium text-blue-600  hover:underline mr-2"
                                            onClick={e => handleFileDownload(e, data?.fairhousing_sign_image)}
                                            >
                                                Download
                                        </button>
                                    </div>
                                </li>
                            )}

                            {/* Home Mortgage Disclosure Act (HMDA) poster/sign */}
                            {/* <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200  mt-8">
                                <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                    Do you have a Home Mortgage Disclosure Act (HMDA) poster/sign in your office?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data?.hdma_sign_option}</span>
                                </div>
                            </li>
                            { data?.hdma_sign_option === 'Yes' && (
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        HDMA Poster/Sign
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <button 
                                            className="font-medium text-blue-600  hover:underline mr-2"
                                            onClick={e => handleFileDownload(e, data?.hdma_sign_image)}
                                            >
                                                Download
                                        </button>
                                    </div>
                                </li>
                            )} */}

                            {/* Labor Law Poster(s) */}
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200  mt-8">
                                <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                    Do you have all applicable, current Labor Law Poster(s)?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data?.labor_law_sign_option}</span>
                                </div>
                            </li>
                            { data?.labor_law_sign_option === 'Yes' && (
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Labor Law Poster
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <button 
                                            className="font-medium text-blue-600  hover:underline mr-2"
                                            onClick={e => handleFileDownload(e, data?.labor_law_sign_image)}
                                            >
                                                Download
                                        </button>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </section>
                </div>
            )

        case 'occupational_license':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                        Occupational / Other Licenses
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200  mt-8">
                                <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                    Does your Town, City or County require an occupational or any other license type to conduct business?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data?._option}</span>
                                </div>
                            </li>
                            { data?._option === 'Yes' && (
                                <>                  
                                    <h1 className="text-lg text-[#0a1445]  font-normal text-center mt-10 mb-4">
                                        Agency website(s) to order license
                                    </h1>             
                                    { data?.agencyWebsite?.map((website, index) => (
                                        <li key={index} className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                            <div className="text-sm text-slate-800  font-medium">
                                                {website?.description}
                                            </div>
                                            <div className="text-sm text-indigo-600  ml-4">
                                                <span className="mr-3">{website?.link}</span>
                                            </div>
                                        </li>
                                    ))}
                                    
                                </>
                            )}
                        </ul>
                    </section>
                </div>
            )

        case 'marketing_details':
            return (
                <div ref={ref} className="px-12 py-6 sm:px-14 overflow-y-auto h-full scrollbar-hide">
                    <h1 className="text-2xl md:text-3xl text-[#0a1445]  font-bold text-center mb-20">
                    Marketing Setup
                    </h1>
                    <section>
                        <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Do you have a team name, location or nickname for your branch/team?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data.isDetails}</span>
                                </div>
                            </li>
                            
                            { data?.isDetails === 'Yes' && (
                                <>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            Company Branch Name
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data.companyBranchName || data.companyTeamName}</span>
                                        </div>
                                    </li>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium">
                                            Company Branch Location
                                        </div>
                                        <div className="text-sm text-slate-600  ml-4">
                                            <span className="mr-3">{data.companyBranchLocation}</span>
                                        </div>
                                    </li>
                                </>
                            )}
                            
                        </ul>
                    </section> 

                    <section>
                        <div className="rounded-lg shadow-sm border-slate-200  w-full mt-10">
                            <ul className='max-w-lg mx-auto'>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Do you have an existing website that you use for your branch/team?
                                    </div>
                                    <div className="text-sm text-indigo-600  ml-4">
                                        <span className="mr-3">{data.isWebsite}</span>
                                    </div>
                                </li>
                                
                                { data?.isWebsite === 'Yes' && (
                                    <>
                                        <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                            <div className="text-sm text-slate-800  font-medium">
                                                Branch Website
                                            </div>
                                            <div className="text-sm text-slate-600  ml-4">
                                                <span className="mr-3">{data.branchWebsite}</span>
                                            </div>
                                        </li>
                                    </>
                                )}
                            </ul>
                        </div>
                    </section>

                    <section>
                        <div className="rounded-lg shadow-sm border-slate-200  w-full mt-10">
                            <h1 className="text-lg text-[#0a1445]  font-medium text-center mb-4">
                                Marketing / Social Media Profiles
                            </h1>
                            <ul className='max-w-lg mx-auto'>
                            <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                <div className="text-sm text-slate-800  font-medium">
                                    Do you have any existing social media profiles for your branch/team?
                                </div>
                                <div className="text-sm text-indigo-600  ml-4">
                                    <span className="mr-3">{data.isSocialMediaProfiles}</span>
                                </div>
                            </li>
                            
                            { data?.isSocialMediaProfiles === 'Yes' && (
                                <>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        LinkedIn
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.branchLinkedIn || 'NA'}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Twitter(X)
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.branchTwitterXProfile || 'NA'}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Facebook
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.branchFacebookProfile || 'NA'}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Instagram
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.branchInstagramProfile || 'NA'}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Zillow
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.branchZillowProfile || 'NA'}</span>
                                    </div>
                                </li>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium">
                                        Google My Business
                                    </div>
                                    <div className="text-sm text-slate-600  ml-4">
                                        <span className="mr-3">{data.branchGoogleMyBusiness || 'NA'}</span>
                                    </div>
                                </li>
                                </>
                            )}
                            </ul>
                        </div>
                    </section>

                    <section>
                        <div className="rounded-lg shadow-sm border-slate-200  w-full mt-10">
                            <h1 className="text-lg text-[#0a1445]  font-medium text-center mb-4">
                                Branch Photos
                            </h1>
                            <ul className='max-w-lg mx-auto'>
                                <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                    <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                        Do you have any branch or team photos you would like our marketing department to use for your team?
                                    </div>
                                    <div className="text-sm text-indigo-600  ml-4">
                                        <span className="mr-3">{data.isTeamPhoto}</span>
                                    </div>
                                </li>
                                {toFileList(data?.teamPhotos).map((photo, index) => 
                                        <li key={index} className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                            <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                                {getFileName(photo)}
                                            </div>
                                            <div className="text-sm text-slate-600  ml-4">
                                                <button 
                                                    className="font-medium text-blue-600  hover:underline mr-3"
                                                    onClick={e => handleFileDownload(e, photo)}
                                                    >
                                                        Download
                                                </button>
                                            </div>
                                        </li>
                                )}
                            </ul>
                        </div>
                    </section>

                    {toFileList(data?.branchPhotos).length > 0 && (
                        <section>
                            <div className="rounded-lg shadow-sm border-slate-200  w-full mt-10">
                                <h1 className="text-lg text-[#0a1445]  font-medium text-center mb-4">
                                    Branch Photo
                                </h1>
                                <ul className='max-w-lg mx-auto'>
                                    <li className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                        <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                            This is a separate pic of the actual physical loacation for google my business.
                                        </div>
                                    </li>
                                    {toFileList(data?.branchPhotos).map((photo, index) => 
                                            <li key={index} className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                                <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                                    {getFileName(photo)}
                                                </div>
                                                <div className="text-sm text-slate-600  ml-4">
                                                    <button 
                                                        className="font-medium text-blue-600  hover:underline mr-3"
                                                        onClick={e => handleFileDownload(e, photo)}
                                                        >
                                                            Download
                                                    </button>
                                                </div>
                                            </li>
                                    )}
                                </ul>
                            </div>
                        </section>
                    )}

                    <section>
                        <div className="rounded-lg shadow-sm border-slate-200  w-full mt-10">
                            <h1 className="text-lg text-[#0a1445]  font-medium text-center mb-4">
                                Branch Images (Optional)
                            </h1>
                            <ul className='max-w-lg mx-auto'>
                                {toFileList(data?.branchImages).map((image, index) => 
                                        <li key={index} className="md:flex md:justify-between md:items-center py-3 border-b border-slate-200 ">
                                            <div className="text-sm text-slate-800  font-medium flex justify-start whitespace-normal">
                                                {getFileName(image)}
                                            </div>
                                            <div className="text-sm text-slate-600  ml-4">
                                                <button 
                                                    className="font-medium text-blue-600  hover:underline mr-3"
                                                    onClick={e => handleFileDownload(e, image)}
                                                    >
                                                        Download
                                                </button>
                                            </div>
                                        </li>
                                )}
                            </ul>
                        </div>
                    </section>
                </div>
            )

        default:
            return (
                <div></div>
            )
    }
})

export default ProfileModalSectionRender;
